module.exports = __webpack_public_path__ + "media/images/icons/warning-72bc3772801a77d68a2a86b35f4e5023.svg";